<template>
  <div id="app">
    <header>
      <nav
        class="flex items-center justify-between flex-wrap p-6 container mx-auto 2xl:max-w-screen-xl"
      >
        <div class="flex items-center flex-shrink-0 mr-6">
          <svg
            class="fill-current h-8 -mr-1 -ml-5"
            width="40"
            height="40"
            viewBox="0 0 100 100"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27 67.9371h31M59.002 67.1666l12.4868-33.1179"
              stroke="#2c3e50"
              stroke-width="15"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span class="font-semibold text-2xl tracking-tight font-mono">
            <a href="/">Restimuli</a>
          </span>
        </div>
        <div class="block lg:hidden">
          <button
            class="flex items-center px-3 py-2 border rounded border-gray-600 hover:text-black hover:border-black focus:outline-none"
            id="nav-toggle"
          >
            <svg
              class="fill-current h-3 w-3"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Menu</title>
              <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
            </svg>
          </button>
        </div>
        <div
          class="w-full block flex-grow lg:flex lg:items-center lg:w-auto hidden"
          id="nav-content"
        >
          <div
            class="text-base lg:flex-grow lg:flex lg:justify-end lg:mr-4 font-medium"
          >
            <a
              href="/submit"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
              >Want to see your company profile here?</a
            >
            <a
              href="/newsletter"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
              >Newsletter</a
            >
            <a
              href="/manifesto"
              class="block mt-4 lg:inline-block lg:mt-0 hover:text-black mr-8"
              >Manifesto</a
            >
            <!-- <a
              href="/covid"
              class="block mt-4 lg:inline-block lg:mt-0 rounded py-0 px-1 hover:text-gray-800 bg-custom-pink text-white text-sm pt-xsmall fit-content mr-3"
              >COVID-19</a
            > -->
            <a
              href="https://publication.restimuli.com/" target="_blank"
              class="block mt-4 lg:inline-block lg:mt-0 rounded py-0.5 px-1.5 hover:text-gray-800 bg-custom-pink text-white text-sm fit-content mr-3"
              >Publication</a
            >
          </div>
          <div>
            <a
              href="/submit"
              class="inline-block text-base px-4 py-2 leading-none border-2 rounded text-white border-white hover:border-transparent hover:text-orange-700 hover:bg-white mt-4 lg:mt-0 font-black"
              >Add Resource</a
            >
          </div>
        </div>
      </nav>
    </header>
    <!-- Hero
    <div
      class="container px-3 mx-auto flex flex-wrap flex-col md:flex-row items-center mb-8 sm:mb-0 mt-16"
    ></div>

    <div class="relative -mt-12 lg:-mt-24">
      <svg
        viewBox="0 0 1428 174"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g
            transform="translate(-2.000000, 44.000000)"
            fill="#f8fafc"
            fill-rule="nonzero"
          >
            <path
              d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
              opacity="0.100000001"
            ></path>
            <path
              d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
              opacity="0.100000001"
            ></path>
            <path
              d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
              id="Path-4"
              opacity="0.200000003"
            ></path>
          </g>
          <g
            transform="translate(-4.000000, 76.000000)"
            fill="#f8fafc"
            fill-rule="nonzero"
          >
            <path
              d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"
            ></path>
          </g>
        </g>
      </svg>
    </div>-->

    <div
      class="bg-cover bg-center profile-banner relative"
      style="background-image: url(https://res.cloudinary.com/imagehosted/image/upload/v1692116547/profileimages/leo_zj8pjz.webp)"
    ></div>

    <section class="bg-gray-100 pb-20 mx-auto">
      <div class="container md:mx-auto pl-3 flex h-24 2xl:max-w-screen-xl">
        <div class="w-32 h-32 relative avatar">
          <div
            class="group w-full h-full rounded border bg-gray-100 overflow-hidden shadow-inner text-center table cursor-pointer"
          >
            <span
              class="hidden group-hover:table-cell text-white font-bold align-middle"
              >KR</span
            >

            <!-- the below when rendering the favicon becomes too stretched, not nice -->
            <!-- <img
              class="object-cover object-center w-full h-full visible group-hover:hidden"
              alt="company logo"
              :src="`${faviconURL}`"
              v-if="faviconURL"
            /><img
              class="object-cover object-center w-full h-full visible group-hover:hidden"
              alt="company logo"
              style="width: 67px;"
              :src="`${logoURL}`"
              v-else-if="!faviconURL"
            /> -->

            <img
              :src="`${logoURL}`"
              alt="company logo"
              class="object-cover object-center w-full h-full visible group-hover:hidden"
            />
          </div>
        </div>
        <div class="flex flex-col mt-2">
        <h1 class="ml-4 text-xl font-semibold">{{ companyName }}</h1>        <!-- addition in case company profile is unclaimed -->
        <span class="hidden md:block ml-4 text-xs font-bold text-custom-pink">This is an unverified profile. Speak with our team to claim this profile.</span>
        <span class="ml-4 text-xs font-bold text-custom-pink block md:hidden">Contact us to claim this profile.</span>        <!-- end of addition in case company profile is unclaimed -->
        <!-- addition in case company profile is claimed -->
          <!-- <span
            class="ml-4 inline-flex rounded border border-bluegray-200 bg-emerald-100 px-2 text-xxs font-bold little-margin justify-center">
            <svg class="mr-1 mt-0.5" fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
              width="8px" height="8px" viewBox="0 0 910.288 910.287"
              xml:space="preserve">
              <g>
                <g>
                  <path d="M873.206,202.06l-1.212-28.51l-28.386-2.915c-109.036-11.198-202.773-51.887-262.21-84.049
                    c-65.099-35.226-104.56-68.274-104.922-68.579L455.165,0L433.84,17.981c-0.392,0.33-39.853,33.379-104.951,68.604
                    c-59.437,32.162-153.173,72.851-262.209,84.049l-28.387,2.915l-1.212,28.51c-0.217,5.104-4.777,126.698,42.059,273.937
                    c27.637,86.887,67.549,164.736,118.627,231.396c64.139,83.701,145.948,149.68,243.155,196.102l14.221,6.793l14.221-6.793
                    c97.207-46.422,179.017-112.398,243.155-196.102c51.079-66.658,90.991-144.51,118.628-231.395
                    C877.982,328.759,873.423,207.165,873.206,202.06z M455.143,836.93c-81.095-41.209-149.731-97.887-204.194-168.646
                    c-46.393-60.275-82.812-130.998-108.248-210.201c-31.088-96.808-38.06-183.144-39.471-225.538
                    c43.735-6.494,87.949-17.421,131.833-32.597c42.9-14.836,85.598-33.752,126.907-56.221c41.915-22.798,73.81-44.573,93.172-58.812
                    c19.362,14.238,51.258,36.014,93.173,58.812c41.309,22.47,84.007,41.385,126.907,56.221
                    c43.896,15.181,88.123,26.108,131.87,32.602c-1.359,41.978-8.194,127.098-38.842,223.443c-25.317,79.594-61.694,150.672-108.12,211.258C605.537,738.494,536.632,795.52,455.143,836.93z"/>
                  <polygon points="635.013,305.016 588.969,351.06 417.368,522.662 330.399,435.693 318.573,423.867 295.239,447.201 
                    295.239,447.202 271.904,470.537 417.368,616 681.682,351.686     "/>
                </g>
              </g>
            </svg>
            VERIFIED PROFILE
            </span> -->
        <!-- end of addition in case company profile is claimed -->  
        </div>
      </div>

      <div class="sm:flex mb-8 container mx-auto pl-3 2xl:max-w-screen-xl">
        <div class="sm:w-2/3 md:w-3/4">
          We are a global company dedicated to advancing the standard of care for the benefit of people with skin conditions, their families and society.
        </div>
        <div class="sm:w-1/3 md:w-1/4 sm:pl-8 pt-6 sm:pt-0">
          <ul>
            <li class="pb-3">
              <a :href="`${linkURL}`">
                <svg
                  class="inline-block mb-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 512 512"
                >
                  <path
                    d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59c-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0c-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606c.648 17.722 3.826 35.527 9.69 52.721c1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96c28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83c-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37c-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569c-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51c27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612c5.864 17.194 9.042 34.999 9.69 52.721c.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
                    fill="#626262"
                  />
                </svg>
                Link
              </a>
            </li>
            <li class="pb-3" v-if="this.linkedinURL">
              <a :href="`${linkedinURL}`">
                <svg
                  class="inline-block mb-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 20 20"
                >
                  <path
                    d="M2.5 18h3V6.9h-3V18zM4 2c-1 0-1.8.8-1.8 1.8S3 5.6 4 5.6s1.8-.8 1.8-1.8S5 2 4 2zm6.6 6.6V6.9h-3V18h3v-5.7c0-3.2 4.1-3.4 4.1 0V18h3v-6.8c0-5.4-5.7-5.2-7.1-2.6z"
                    fill="#626262"
                  />
                </svg>
                Linkedin
              </a>
            </li>

            <li class="pb-3" v-if="this.twitterURL">
              <a :href="`${twitterURL}`">
                <svg
                  class="inline-block mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  focusable="false"
                  width="1em"
                  height="1em"
                  style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 1024 1024"
                >
                  <path
                    d="M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94a336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6c0 13.2 1.6 26.4 4.2 39.1c-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9c-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850C671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2c33.2-24.3 62.3-54.4 85.5-88.2z"
                    fill="#626262"
                  />
                </svg>
                Twitter
              </a>
            </li>

            <li class="pb-3" v-if="this.blogURL">
              <a :href="`${blogURL}`">
                <svg
                  class="inline-block mb-1 mr-2"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  focusable="false"
                  width="0.88em"
                  height="1em"
                  style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                  preserveAspectRatio="xMidYMid meet"
                  viewBox="0 0 448 512"
                >
                  <path
                    d="M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041s64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018c111.832 7.284 201.473 96.702 208.772 208.772c.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01C7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999c191.179 7.839 344.627 161.316 352.465 352.465c.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
                    fill="#626262"
                  />
                </svg>
                Impact
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex justify-center text-xs  md:text-lg">
        <ul class="flex container absolute w-11/12 2xl:max-w-screen-xl">
          <li class="-mb-px mr-2">
            <a
              class="bg-custom-pink inline-block rounded-t-lg py-2 px-4 font-bold text-white"
              href="#values"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="inline mr-2"
                aria-hidden="true"
                focusable="false"
                width="0.88em"
                height="1em"
                style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 14 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M7 4c-.83 0-1.5-.67-1.5-1.5S6.17 1 7 1s1.5.67 1.5 1.5S7.83 4 7 4zm7 6c0 1.11-.89 2-2 2h-1c-1.11 0-2-.89-2-2l2-4h-1c-.55 0-1-.45-1-1H8v8c.42 0 1 .45 1 1h1c.42 0 1 .45 1 1H3c0-.55.58-1 1-1h1c0-.55.58-1 1-1h.03L6 5H5c0 .55-.45 1-1 1H3l2 4c0 1.11-.89 2-2 2H2c-1.11 0-2-.89-2-2l2-4H1V5h3c0-.55.45-1 1-1h4c.55 0 1 .45 1 1h3v1h-1l2 4zM2.5 7L1 10h3L2.5 7zM13 10l-1.5-3l-1.5 3h3z"
                  fill="#FFFFFF"
                />
                <rect
                  x="0"
                  y="0"
                  width="14"
                  height="16"
                  fill="rgba(0, 0, 0, 0)"
                /></svg
              >Values
            </a>
          </li>
          <li class="mr-2">
            <a
              class="bg-gray-200 inline-block rounded-t-lg py-2 px-4 transform hover:scale-105 hover:bg-gray-200 font-normal"
              href="#offerings"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="inline mr-2"
                aria-hidden="true"
                focusable="false"
                width="1em"
                height="1em"
                style="-ms-transform: rotate(360deg); -webkit-transform: rotate(360deg); transform: rotate(360deg);"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#626262"
                  d="M12 6V0H4v6H0v7h16V6h-4zm-5 6H1V7h2v1h2V7h2v5zM5 6V1h2v1h2V1h2v5H5zm10 6H9V7h2v1h2V7h2v5z"
                />
                <path fill="#626262" d="M0 16h3v-1h10v1h3v-2H0v2z" />
                <rect
                  x="0"
                  y="0"
                  width="16"
                  height="16"
                  fill="rgba(0, 0, 0, 0)"
                /></svg
              >Offerings
            </a>
          </li>
          <!-- <li class="mr-1">
    <a class="bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800 font-semibold" href="#">Tab</a>
          </li>-->
          <!-- to make tab disappear in case there is no donations -->
          <!-- <li v-if="testDonateTile === true"> -->
          <li>
            <!-- to make the text change color from disabled to enabled depending on whether there is a donation offered -->
            <a
              v-bind:class="[
                testDonateTile
                  ? 'bg-gray-200 inline-block rounded-t-lg py-2 px-4 transform hover:scale-105 hover:bg-gray-200 font-normal'
                  : 'bg-gray-200 inline-block rounded-t-lg py-2 px-4 text-gray-400 font-normal',
              ]"
              href="#donating"
            >
              <!-- color of icon changes depending on whether there is anything donated -->
              <svg
                class="inline mr-1"
                height="1.3em"
                viewBox="0 0 1024 1024"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M856.192 178.62c-25.825-27.854-55.024-51.288-84.422-67.761-21.109-11.844-62.7-26.05-110.45-27.105-58.122-1.27-108.613 17.26-145.98 53.634l-.228.223-19.852 19.753-13.833-13.754-.224-.22c-24.13-23.479-51.495-40.149-81.337-49.546-27.704-8.723-56.995-11.042-87.06-6.887-54.29 7.502-107.847 35.638-150.806 79.226-42.073 42.69-68.78 95.138-75.202 147.682-3.57 29.216-.807 57.634 8.212 84.466 9.677 28.783 26.399 55.174 49.692 78.426l36.391 36.37-1.604 1.603c-29.55 29.672-29.538 77.9.026 107.513l.073.071 5.367 5.338c13.195 13.175 30.463 20.89 49.04 22.007 1.691 16.824 8.944 33.194 21.757 46.072l.107.106 5.365 5.335c14.295 14.317 33.396 22.202 53.786 22.202h.225c2.514 15.685 9.854 30.13 21.317 41.592l5.402 5.374c13.827 13.875 32.184 21.699 51.872 22.151 2.382 16.034 9.774 30.79 21.39 42.386l5.379 5.38c14.292 14.293 33.394 22.164 53.788 22.164 20.402 0 39.502-7.877 53.779-22.177l46.89-46.95a75.973 75.973 0 0010.381-12.965c11.592 6.986 24.789 10.66 38.65 10.66 1.94 0 3.892-.07 5.855-.216 19.325-1.424 38.518-10.122 52.656-23.863 10.333-10.043 18.242-23.264 21.632-38.047.244.003.488.019.732.019a80.48 80.48 0 007.059-.314c19.354-1.71 38.676-10.68 53.011-24.611 12.915-12.551 21.086-28.282 23.436-44.848 15.336-1.943 29.975-9.057 41.932-20.558 14.43-13.879 23.905-33.236 25.995-53.104 1.84-17.495-1.96-34.27-10.794-48.59l36.2-36.146c98.225-98.074 57.892-232.463-25.605-322.092zM251.489 586.596c-3.351 3.346-7.89 5.188-12.779 5.188-4.88 0-9.412-1.843-12.803-5.228l-5.352-5.322c-6.89-6.922-6.873-18.623.005-25.53l70.022-70.052c3.356-3.357 7.885-5.206 12.751-5.206 4.864 0 9.413 1.84 12.825 5.183l5.14 5.227c.056.058.114.115.171.172 3.369 3.37 5.222 7.916 5.217 12.802-.004 4.85-1.843 9.349-5.227 12.72l-69.97 70.046zm76.332 73.552c-3.366 3.36-7.915 5.21-12.809 5.21-4.877 0-9.398-1.838-12.804-5.249l-5.372-5.342c-6.885-6.967-6.887-18.66-.003-25.555l111.43-111.49c3.415-3.395 7.993-5.265 12.892-5.265 4.872 0 9.409 1.853 12.712 5.152l5.461 5.49c6.908 6.907 6.904 18.588-.003 25.5L327.821 660.15zm80.62 69.143c-3.368 3.357-7.913 5.206-12.8 5.206-4.84 0-9.317-1.818-12.603-5.121a5.117 5.117 0 01-.105-.106l-5.413-5.383c-3.384-3.385-5.245-7.927-5.24-12.788.006-4.809 1.85-9.287 5.244-12.666l76.492-76.523c3.348-3.353 7.863-5.2 12.712-5.2 4.86 0 9.387 1.853 12.807 5.272l5.358 5.33c7.01 7.076 7.005 18.539-.003 25.558l-76.448 76.42zm125.577 22.992l-46.906 46.967c-3.319 3.324-7.839 5.155-12.727 5.155-4.898 0-9.431-1.837-12.764-5.17l-5.397-5.398c-3.37-3.364-5.224-7.901-5.223-12.777.002-4.852 1.851-9.366 5.247-12.75l46.897-46.927c3.364-3.365 7.902-5.218 12.777-5.218.94 0 1.86.089 2.767.225.362.406.734.807 1.122 1.198l19.217 19.33c.118.855.199 1.72.198 2.602-.002 4.874-1.846 9.402-5.208 12.763zM790.18 596.74c-5.277 5.076-12.964 9.224-25.666-3.859l-99.006-102.159c-11.148-11.503-29.512-11.791-41.017-.642-11.504 11.149-11.792 29.513-.643 41.017l6.219 6.417c.216.239.43.48.656.712l91.647 94.53.495.51c6.596 6.8 13.953 17.212 1.732 29.086-7.414 7.206-22.018 13.083-31.258 3.588L592.002 561.826c-11.177-11.482-29.54-11.728-41.02-.555-11.48 11.175-11.728 29.539-.553 41.02l83.083 85.36a28.914 28.914 0 005.901 9.173c10.51 11.04 11.385 20.091 2.749 28.483-6.947 6.753-21.006 11.954-30.539 2.348l-22.665-22.799a75.691 75.691 0 00-13.904-19.118l-.17-.169-5.35-5.26c-7.27-7.303-15.793-12.926-25.105-16.682 8.497-26.326 2.335-56.422-18.485-77.31l-.088-.088-5.35-5.323c-6.9-6.9-14.91-12.306-23.634-16.056 11.32-27.544 5.823-60.427-16.465-82.717l-5.47-5.5c-14.32-14.308-33.42-22.189-53.78-22.189-16.33 0-31.868 5.072-44.824 14.496a75.813 75.813 0 00-13.746-18.84l-5.21-5.297-.238-.239c-14.365-14.27-33.472-22.13-53.803-22.13-20.362 0-39.46 7.883-53.778 22.2l-27.447 27.46-36.405-36.385c-72.388-72.26-43.31-166.984 17.618-228.805 61.269-62.166 161.645-95.563 237.321-22.038l13.494 13.418-91.744 91.286c-14.735 14.66-17.909 29.474-17.977 39.32-.094 13.681 5.448 26.56 16.027 37.245 16.344 16.508 43.835 26.429 73.539 26.537l.5.001c32.658 0 62.533-11.72 84.157-33.025l38.034-37.445c9.804-8.676 19.913-8.976 39.857-3.859-10.184 11.16-10.134 28.458.453 39.553L793.671 564.01c9.963 10.454 3.805 25.71-3.49 32.731zm50.626-137.082l-34.066 34.015L654.264 333.89c9.885 1.871 20.266 3.11 31.07 3.11 26.782 0 56.12-7.562 86.654-31.654 12.576-9.923 14.728-28.163 4.803-40.74-9.924-12.577-28.163-14.727-40.74-4.804-36.461 28.77-67.562 19.37-103.579 8.484-34.333-10.376-77.06-23.29-115.172 11.302-.29.263-.576.533-.854.808l-38.517 37.92c-16.95 16.698-40.09 16.837-49.253 16.119-10.713-.837-18.406-3.716-22.897-6.197L555.914 178.85c61.046-59.274 158.76-33.506 187.48-17.39 24.2 13.558 48.494 33.13 70.3 56.652 59.808 64.199 102.794 165.979 27.112 241.545z"
                  v-bind:style="[
                    testDonateTile ? { fill: '#626262' } : { fill: '#cbd5e0' },
                  ]"
                />
              </svg>
              Donating
            </a>
          </li>
          <div
            class="h-1 absolute bottom-0 bg-custom-pink rounded-t w-full"
          ></div>
        </ul>
      </div>
    </section>

    <section class="bg-gray-100 -mt-1" id="values">
      <div class="sm:flex container mx-auto px-2 pt-4 pb-6 text-gray-800 2xl:max-w-screen-xl">
        <div class="sm:w-2/3 md:w-3/4">
          <h2
            class="values w-full my-2 text-xl sm:text-3xl font-bold leading-tight text-gray-800"
          >
            Top Company Values
          </h2>
          <div class="w-full mb-4">
            <div
              class="h-1 gradient w-48 sm:w-64 opacity-25 my-0 py-0 rounded-t"
            ></div>
          </div>
          <h2
            class="w-full my-2 text-xl font-black leading-tight text-custom-pink pt-4"
          >
          Published modern slavery statement
          </h2>
          <h3 class="mt-5">
            <strong
              >Leo Pharma's Journey Towards a Modern Slavery-Free World.</strong
            >
          </h3>
          <p class="mt-5 text-justify">
            At the heart of Leo Pharma's commitment to the welfare of humanity, lies their stance against modern slavery. The company has gone beyond mere declarations by publishing a comprehensive modern slavery statement, making a public pledge to root out such practices from their operations and supply chains. 
          </p>
                    <p class="mt-3 text-justify">

          They've initiated rigorous audits within their supply chains, ensuring that every link, from raw material suppliers to distributors, adheres to the strictest human rights standards. This is no small feat for a company with such a vast and interconnected network of partners, but Leo Pharma deems it indispensable.                    </p>
                              <p class="mt-3 text-justify">
          Recognizing the importance of continuous improvement, Leo Pharma employs an intricate system of checks and balances. Regular audits are carried out, aimed at not only maintaining but elevating the human rights standards they’ve set. This dedication is a testament to the importance they place on ethical responsibility, especially in today's interconnected global economy.</p>
                  <p class="mt-3 text-justify">


          Addressing modern slavery is not a static endeavor—it evolves as the world around us changes. With that understanding, Leo Pharma has invested in research and strategies that keep their commitments fresh and relevant. By always staying ahead and proactive, they ensure that their ethical foundations are not just maintained but strengthened with time.</p>
          <p class="mt-3 text-justify">


            Accountability is key, and Leo Pharma has put in place specific key performance indicators (KPIs) related to their modern slavery initiatives. These KPIs offer a tangible and quantifiable way to monitor and assess their progress, ensuring they remain on track and dedicated to their cause.

</p>

          <img
            class="values-img"
            src="https://res.cloudinary.com/imagehosted/image/upload/v1692116642/profileimages/leo2_nkajs2.jpg"
          />
          <h2
            class="w-full my-2 text-xl font-black leading-tight text-custom-pink pt-4"
          >
          Actively manages ethical and sustainability standards in its supply chain
          </h2>
          <h3 class="mt-5">
            <strong
              >Rigor and Integrity in Every Supply Chain Link.</strong
            >
          </h3>
           <!-- addition of overlay div to body of text for unclaimed profiles; Positioned where the overlay starts -->
          <div class="relative">
          <!-- end of closing of the div that add overlay to body for unclaimed profiles -->
          <p class="mt-5 text-justify">
            Leo Pharma’s approach to supply chain management is anchored in a clear commitment to ethical and sustainable standards. Recognizing the critical role suppliers play in the overall integrity of their operations, the company ensures rigorous vetting of all partners, from raw material providers to end-product distributors.          </p>
          <p class="mt-3 text-justify">
            This isn't about mere compliance; it's about setting industry standards. Leo Pharma conducts regular audits throughout their supply chain. This systematic review guarantees that every partner aligns with the company's ethical guidelines. It's a proactive measure, designed to preempt potential challenges and ensure consistent alignment with their core values.

          </p>
          <p class="mt-3 text-justify">
            Internal education is a cornerstone of Leo Pharma's strategy. By instituting specialized training programs for its team, the company ensures that its employees are not only aware of the ethical guidelines but are also equipped to enforce and uphold them in their respective roles. It's a proactive step toward building a culture centered around ethical operations.
          </p>
          <p class="mt-3 text-justify">
            Recognizing that ethical standards evolve with time, Leo Pharma maintains a dynamic approach. The company is dedicated to continuous research and adaptation, ensuring that their guidelines and practices always remain at the forefront of ethical supply chain management.



          </p>
          <p class="mt-3 text-justify">
            To measure the effectiveness of their ethical initiatives, Leo Pharma employs specific key performance indicators (KPIs). These metrics provide a clear and objective measure of how well the company is doing in maintaining its commitment to ethical supply chain management, allowing for constant assessment and improvement.





          </p>
          <img
            class="values-img"
            src="https://res.cloudinary.com/imagehosted/image/upload/v1692116814/profileimages/leo3_m6wxvu.jpg"
          />
          <h2
            class="w-full my-2 text-xl font-black leading-tight text-custom-pink pt-4"
          >
          Actively practices inclusion
          </h2>
          <h3 class="mt-5">
            <strong
              >Inclusion in Action, Diversity in Thought.</strong
            >
          </h3>
          <p class="mt-5 text-justify">
            Inclusion a guiding principle at Leo Pharma. As a global player, the company has recognized that embracing a diverse workforce is crucial to fostering innovation, understanding different patient needs, and addressing challenges from multiple perspectives.          </p>
          <p class="mt-3 text-justify">
            The commitment to inclusion begins from the moment an individual steps into the company. Recruitment processes at Leo Pharma have been refined to ensure a broad spectrum of candidates from different backgrounds, skills, and perspectives are considered. By doing this, they're not just expanding their talent pool but also ensuring a dynamic mix of thought within the organization.          </p>
          <p class="mt-3 text-justify">
            Within the company, Leo Pharma has established various employee resource groups (ERGs). These groups offer a platform for employees from various backgrounds to come together, share experiences, and drive initiatives that promote inclusivity. While acting as support networks, these ERGs also play an essential role in shaping company policies and practices.

</p>
          <p class="mt-3 text-justify">
            Training and awareness programs form another crucial aspect of Leo Pharma's inclusion strategy. Employees undergo regular sessions designed to broaden their understanding of diversity, tackle unconscious biases, and foster an environment where everyone feels valued and heard. It's not just about co-existing—it's about thriving together.

</p>
          <p class="mt-3 text-justify">
            Leo Pharma has also set specific benchmarks to track their progress in inclusivity. By monitoring various metrics—from gender representation in leadership roles to the effectiveness of their diversity training programs—the company maintains a clear and focused path towards a more inclusive future.


          </p>
          <img
            class="values-img"
            src="https://res.cloudinary.com/imagehosted/image/upload/v1692116881/profileimages/leo4_xkaxh8.jpg"
          />
          
          <!-- addition of overlay div to body of text for unclaimed profiles. Positioned at the end of the overlay -->
          <div class="absolute inset-0 bg-gradient-to-b from-gray-100 via-gray-100 to-gray-100 opacity-80 p-10" ></div>
          <div class="absolute top-96 w-full flex items-center justify-start z-20 flex-col space-y-96">
            <p class="text-center font-bold text-custom-pink text-xl">Speak with our team to claim this profile.</p>
            <!-- as many as needed of the below to cover the overlay with text , for mobile a different <p> is below-->
            <p class="text-center font-bold text-custom-pink text-xl">Speak with our team to claim this profile.</p>
            <p class="text-center font-bold text-custom-pink text-xl">Speak with our team to claim this profile.</p>
            <p class="text-center font-bold text-custom-pink text-xl">Speak with our team to claim this profile.</p>
            
            <!-- the below are to cover the overlay in mobile view -->
            <p class="text-center font-bold text-custom-pink text-xl md:hidden">Speak with our team to claim this profile.</p>
            
            </div>
          </div>
          <!-- end of closing of the div that add overlay to body for unclaimed profiles -->
        </div>
        <div class="sm:w-1/3 md:w-1/4 sm:pl-8 pt-6 sm:pt-0">
          <div
            class="py-4 px-6 bg-white shadow border rounded items-start justify-center w-full"
          >
            <h2
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Values
            </h2>
            <ul class="text-sm">
              <li><h3>Published modern slavery statement</h3></li>              
              <li class="mt-3"><h3>Actively manages ethical and sustainability standards in its supply chain</h3></li>
              <li class="mt-3"><h3>Actively practices inclusion</h3></li>
              <!-- <li class="mt-3">Subsidizes childcare</li>
              <li class="mt-3"><h3>Has Corporate Responsibility / Sustainability Board Committee</h3></li>
              <li class="mt-3"><h3>
                Published modern slavery statement
              </h3></li>
              <li class="mt-3">
                Own distribution warehouses
              </li> -->
            </ul>
          </div>
          <div
            class="py-4 px-6 bg-white shadow border rounded items-start justify-center w-full mt-8"
          >
            <h2
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Company Properties
            </h2>
            <ul class="text-sm">
              <li><h3>Trading for 100+ years</h3></li>

              <!-- <li class="mt-3"><h3>Trading for 50+ years</h3></li> -->
              <!-- <li class="mt-3">Owned by a minority group</li>
              <li class="mt-3">Technical Founder(s)</li>
              <li class="mt-3">Plastic free certified</li>
              <li class="mt-3">PBC / B-CORP</li>
              <li class="mt-3">Carbon Neutral Certified</li>
              <li class="mt-3"><h3>Trading for 50+ years</h3></li> -->
            </ul>
          </div>
          <div
            class="py-4 px-6 bg-white shadow border rounded items-start justify-center w-full mt-8"
          >
            <h2
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Locations
            </h2>
            <ul class="text-sm">
              <li><h3>Europe HQ</h3></li>


              <!-- <li class="mt-3">Products/Services Designed in Oceania</li>
              <li class="mt-3">Local Offices in Oceania</li>
              <li class="mt-3">Products/Services Made/Provided in Africa</li>
              <li class="mt-3">Supplies to Europe</li> -->
            </ul>
          </div>
          <div
            class="py-4 px-6 bg-white shadow border rounded items-start justify-center w-full mt-8"
          >
            <h2
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Resources
            </h2>
            <ul class="text-sm">
              <li class="mt-3"><h3>Pharmaceuticals</h3></li> 
              <!-- <li class="mt-3">Medical Equipment</li> -->
              <!-- <li class="mt-3"><h3>Diagnostics</h3></li> -->

              <!-- <li class="mt-3">Social Distancing Measures</li>
              <li class="mt-3">Work Protection Kits</li>
              <li class="mt-3">Chemicals</li>
              <li class="mt-3">Polymers</li>
              <li class="mt-3">Textiles</li>
              <li class="mt-3">Medical Testing Equipment & Consumables</li>
              <li class="mt-3">Complete Medical Tests</li>
              <li class="mt-3">Diagnostic</li>
              <li class="mt-3">Laboratory Capacity</li>
              <li class="mt-3">Transport / Logistics</li>
              <li class="mt-3">
                Packing / Kitting / Distribution / Fulfilment
              </li>
              <li class="mt-3">Medical Services</li>
              <li class="mt-3">Workplace Services</li>
              <li class="mt-3">Deep Cleaning</li>
              <li class="mt-3">Sanitiser</li>
              <li class="mt-3">Disinfectants</li> -->
            </ul>
          </div>
          
          <div
            class="py-4 px-6 shadow border rounded items-center justify-center w-full mt-8 text-center gradient overflow-hidden sticky top-8 hidden sm:block"
          >
            <p
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Get new company profiles every week!
    </p>
            <form action="https://restimuli.us5.list-manage.com/subscribe/post" method="POST" target="_blank">
                <input type="hidden" name="u" value="f82c7f82dbca46f5f83765b6a">
                <input type="hidden" name="id" value="36cf36b57d">
                <input class="appearance-none bg-white py-2 px-2 focus:outline-none focus:bg-gray-100 focus:border-orange-900 text-sm placeholder-orange-600 newsletter_placeholder border-2 border-white rounded mx-auto flex flex-wrap w-11/12"
            type="email"
            :placeholder="' ' + icon + '   Enter your email...'"
            aria-label="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="">
                 <button class="bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 focus:outline-none" type="submit">
                  Get new profiles
                </button>

                <!-- class="flex-shrink-0 bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 md:mt-0 focus:outline-none" -->

                
             </form> 
          </div>

          
        </div>
      </div>
    </section>

    <section class="bg-gray-100 pt-20 -mt-1" id="offerings">
      <div class="container mx-auto px-2 pt-4 pb-6 text-gray-800 2xl:max-w-screen-xl">
        <h2
          class="w-full my-2 text-xl sm:text-3xl font-bold leading-tight text-gray-800"
        >
          Offerings at {{companyNameVar}}
        </h2>
        <div class="w-full mb-4">
          <div
            class="h-1 gradient w-64 sm:w-1/3 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>

        <div class="px-4 w-full my-2" v-if="error">
          <p class="border-2 border-red-400 rounded inline p-2 text-red-600">
            {{ error }}
          </p>
        </div>

        <div class="w-full flex flex-wrap" v-if="showServicesByCompany.length">
          <template v-for="serviceByCompany in showServicesByCompany">
            <div
              class="md:w-1/3 flex flex-wrap relative content-div"
              v-if="!serviceByCompany.driveToPaidFlag"
              :key="serviceByCompany.id"
            >
              <a
                class="m-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out fd-cl"
              >
                <div
                  class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow pb-10"
                >
                <!-- Overlay div to grey out the front of the tile -->
                <div
                class="overlay absolute inset-0 bg-gray-300 opacity-70 z-10"
                v-if="!serviceByCompany.driveToPaidFlag"
                ></div>
                <!-- End of Overlay div to grey out the front of the tile -->
                  <div
                    class="flex flex-wrap text-left no-underline hover:no-underline"
                  >
                    <!-- <div
                    class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 flex items-center"
                  > -->
                    <!-- <img
                      class="inline rounded-sm mr-2"
                      style="width: 30px; heigth: 30px;"
                      :src="service.favicon_url"
                      v-if="service.favicon_url"
                    />
                    <img
                      class="inline rounded-sm img_profile_margin -ml-10"
                      style="width: 100px;"
                      :src="serviceByCompany.logo_url"
                      v-else-if="!serviceByCompany.favicon_url"
                    /> -->
                    <!-- {{ serviceByCompany.company_name }} -->
                    <!-- This is the flag sth wrong with the listing mechanism -->
                    <!-- <a
                    class="p-2 ml-auto rounded bg-gray-200 hover:bg-gray-400"
                    :title="`Flag ${service.name}`"
                    :href="
                      `https://twitter.com/share?url=${encodeURIComponent(
                        'https://restimuli.com'
                      )}&text=${encodeURIComponent(
                        `Hi @AdriaanvRossum, there is something wrong with the '${service.name}' listing.\n\n(please replace this line with what is wrong...)\n\n`
                      )}`
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18.827 7.806c-4.225 0-4.491-6.806-9.666-6.806-1.535 0-2.951.628-4.161 1.482v-2.482h-2v24h2v-10.427c1.064-1.302 2.316-2.021 4.205-2.021 2.219 0 3.592.841 5.368.841 3.127 0 4.938-2.379 6.428-5.083-.832.345-1.547.496-2.174.496zm-4.255 2.588c-1.399 0-2.882-.841-5.368-.841-1.761 0-3.108.508-4.205 1.292v-5.784c.999-.951 2.517-2.061 4.162-2.061 1.621 0 2.444 1.025 3.759 2.836.987 1.359 2.159 2.974 4.022 3.648-.74.633-1.5.91-2.37.91z"
                      />
                    </svg>
                    </a>-->
                    <!-- </div> -->
                    <div
                      class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 items-center"
                    >
                      {{ serviceByCompany.offering_name }}
                      <p class="font-medium text-lg">
                        by
                        <img
                          class="inline rounded-sm mr-1"
                          style="width: 20px; heigth: 20px;"
                          :src="serviceByCompany.favicon_url"
                          v-if="serviceByCompany.favicon_url"
                        /><img
                          class="inline rounded-sm -mr-5 -ml-6 "
                          style="width: 67px;"
                          :src="serviceByCompany.logo_url"
                          v-else-if="!serviceByCompany.favicon_url"
                        />
                        {{ serviceByCompany.company_name }}
                      </p>
                    </div>
                    <p class="text-gray-800 text-base px-6 mb-2 mt-3">
                      <span
                        class="inline-flex rounded-full bg-bluegray-200 px-2 text-xs font-bold little-margin"
                        >{{ serviceByCompany.category }}</span
                      >
                      {{ serviceByCompany.description }}
                    </p>
                    <p
                      class="text-gray-600 text-xs px-6 mb-5"
                      v-if="serviceByCompany.requirement"
                    >
                      <strong>Requirement</strong>
                      {{ serviceByCompany.requirement }}
                    </p>
                    <p
                      :class="
                        `text-${serviceByCompany.driveToPaidColor ||
                          'gray'}-600 text-xs px-6 mb-5`
                      "
                      v-if="serviceByCompany.driveToPaidText"
                    >
                      {{ serviceByCompany.driveToPaidText }}
                    </p>
                  </div>
                </div>
                <div
                  class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6"
                >
                  <!-- Information on how to apply -->
                  <!-- <p class="text-left text-sm">
                <span v-if="service.how_to_apply_text.endsWith('.')">
                  {{
                  service.how_to_apply_text
                  }}
                </span>
                <span v-else-if="service.how_to_apply_text">{{ service.how_to_apply_text }}.</span>
                <span v-if="service.discount.length > 10">{{ service.discount }}</span>
                </p>-->
                  <!-- Information on location -->
                  <p class="text-gray-800 text-base mb-2 mt-3">
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      >{{ serviceByCompany.supplies_to }}</span
                    >
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      v-if="serviceByCompany.country_of_design"
                      >{{ serviceByCompany.country_of_design }}</span
                    >
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      v-if="serviceByCompany.country_of_manufacture"
                      >{{ serviceByCompany.country_of_manufacture }}</span
                    >
                  </p>

                  <div class="flex items-center justify-start">
                    <!-- This is to change the color and design of the button in case an email and not a url is provided to the how to apply -->
                    <!-- <a
                  :href="
                    service.useEmail
                      ? `mailto:${service.how_to_apply_url_or_email}&subject=Discount%20to%20fight%20COVID-19`
                      : `${service.how_to_apply_url_or_email}?utm_source=restimuli.com`
                  "
                  :class="
                    `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${
                      service.useEmail
                        ? 'text-custom-pink border-2 border-custom-pink py-3'
                        : 'text-white gradient py-4'
                    }`
                  "
                >
                  <svg
                    v-if="service.useEmail"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#ed6ea0"
                    class="inline mr-2 -ml-2"
                  >
                    <path
                      d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"
                    />
                  </svg>-->
                    <!-- <span v-if="service.discount.length > 10">Get this discount</span>
                  <span v-else>Get {{ service.discount }} discount</span>-->
                    <a
                      :class="
                        `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${'text-white gradient py-4'}`
                      "
                    >
                      <span>Know more</span>
                    </a>
                  </div>
                </div>
              </a>

              <!-- this is the flip side of the card -->
              <!-- <a
              class="absolute h-full w-full p-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out opacity-0 fd-sh"
              :href="
                service.how_to_apply_url_or_email.includes('@')
                  ? `${service.url}/?ref=restimuli.com`
                  : service.how_to_apply_url_or_email.includes('?')
                  ? `${service.how_to_apply_url_or_email}&ref=restimuli.com`
                  : `${service.how_to_apply_url_or_email}?ref=restimuli.com`
              "
            >-->
              <a
                class="absolute h-full w-full p-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out opacity-0 fd-sh"
                :href="
                  serviceByCompany.how_to_contact_url_or_email.includes('@')
                    ? `${serviceByCompany.how_to_contact_url_or_email}`
                    : serviceByCompany.how_to_contact_url_or_email.includes('?')
                    ? `${serviceByCompany.how_to_apply_url_or_email}`
                    : `${serviceByCompany.how_to_apply_url_or_email}`
                "
              >
                <div
                  class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow"
                >
                  <div
                    class="flex flex-wrap text-left no-underline hover:no-underline"
                  >
                    <div
                      class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 items-center"
                    >
                      {{ serviceByCompany.offering_name }}
                      <p class="font-medium text-lg">
                        by
                        <img
                          class="inline rounded-sm mr-1"
                          style="width: 20px; heigth: 20px;"
                          :src="serviceByCompany.favicon_url"
                          v-if="serviceByCompany.favicon_url"
                        /><img
                          class="inline rounded-sm -mr-5 -ml-6 "
                          style="width: 67px;"
                          :src="serviceByCompany.logo_url"
                          v-else-if="!serviceByCompany.favicon_url"
                        />
                        {{ serviceByCompany.company_name }}
                      </p>
                    </div>

                    <div
                      class="text-gray-800 text-base px-6 mb-2 mt-3 flex flex-wrap "
                    >
                      <p
                        class="text-xs font-bold mtop-s mright-sm "
                        v-if="serviceByCompany.certification_1"
                      >
                        Certification
                      </p>
                      <p class="text-sm ">
                        {{ serviceByCompany.certification_1 }}
                      </p>
                      <p
                        class="text-sm "
                        v-if="serviceByCompany.certification_2"
                      >
                        , {{ serviceByCompany.certification_2 }}
                      </p>
                      <p
                        class="text-sm "
                        v-if="serviceByCompany.certification_3"
                      >
                        , {{ serviceByCompany.certification_3 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_4"
                      >
                        , {{ serviceByCompany.certification_4 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_5"
                      >
                        , {{ serviceByCompany.certification_5 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_6"
                      >
                        , {{ serviceByCompany.certification_6 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_7"
                      >
                        , {{ serviceByCompany.certification_7 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_8"
                      >
                        , {{ serviceByCompany.certification_8 }}
                      </p>
                    </div>
                  </div>
                  <p
                    :class="`text-gray-600 text-xs px-6 mb-5 mt-1`"
                    v-if="
                      serviceByCompany.plastic_in_item_or_packaging.includes(
                        'No'
                      )
                    "
                  >
                    {{ serviceByCompany.plastic_in_item_or_packaging }}
                  </p>
                </div>

                <div
                  class="flex-none mt-auto bg-white rounded-b rounded-t-none shadow-lg p-6"
                >
                <!-- Overlay div to grey out the back of the tile -->
                <div
                class="overlay absolute inset-0 bg-gray-300 opacity-70 z-10 m-6"
                v-if="!serviceByCompany.driveToPaidFlag"
                ></div>
                <!-- End of Overlay div to grey out the back of the tile --> 
                  <p class="text-gray-800 text-base mb-2 mt-3">
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      >{{ serviceByCompany.type_of_business }}</span
                    >
                  </p>

                  <div class="flex items-center justify-start">
                    <a
                      :href="`${serviceByCompany.how_to_contact_url_or_email}`"
                      :class="
                        `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${'text-white gradient py-4'}`
                      "
                    >
                      <span>Know more</span>
                    </a>
                  </div>
                </div>
              </a>
            </div>
          </template>
        </div>

        <div v-else-if="loading" class="w-full mt-8">
          <p class="text-center">Loading products...</p>
        </div>
        <div v-else class="w-full mt-8">
          <p class="text-center">Select an option above.</p>
        </div>
      </div>
    </section>

    <section
      v-if="testDonateTile === true"
      class="bg-gray-100 pt-20 -mt-1"
      id="donating"
    >
      <div class="container mx-auto px-2 pt-4 pb-6 text-gray-800 2xl:max-w-screen-xl">
        <h2
          class="w-full my-2 text-xl sm:text-3xl font-bold leading-tight text-gray-800"
        >
          Donating at {{companyNameVar}}
        </h2>
        <div class="w-full mb-4">
          <div
            class="h-1 gradient w-64 sm:w-1/3 opacity-25 my-0 py-0 rounded-t"
          ></div>
        </div>

        <div class="px-4 w-full my-2" v-if="error">
          <p class="border-2 border-red-400 rounded inline p-2 text-red-600">
            {{ error }}
          </p>
        </div>

        <div class="w-full flex flex-wrap" v-if="showServicesByCompany.length">
          <template v-for="serviceByCompany in showServicesByCompany">
            <div
              class="md:w-1/3 flex flex-wrap relative content-div"
              v-if="serviceByCompany.driveToPaidFlag"
              :key="serviceByCompany.id"
            >
              <a
                class="m-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out fd-cl"
              >
                <div
                  class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow pb-10"
                >
                <!-- Overlay div to grey out the front of the tile -->
                <div
                class="overlay absolute inset-0 bg-gray-300 opacity-70 z-10"
                v-if="serviceByCompany.driveToPaidFlag"
                ></div>
                <!-- End of Overlay div to grey out the front of the tile -->
                  <div
                    class="flex flex-wrap text-left no-underline hover:no-underline"
                  >
                    <!-- <div
                    class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 flex items-center"
                  > -->
                    <!-- <img
                      class="inline rounded-sm mr-2"
                      style="width: 30px; heigth: 30px;"
                      :src="service.favicon_url"
                      v-if="service.favicon_url"
                    />
                    <img
                      class="inline rounded-sm img_profile_margin -ml-10"
                      style="width: 100px;"
                      :src="serviceByCompany.logo_url"
                      v-else-if="!serviceByCompany.favicon_url"
                    /> -->
                    <!-- {{ serviceByCompany.company_name }} -->
                    <!-- This is the flag sth wrong with the listing mechanism -->
                    <!-- <a
                    class="p-2 ml-auto rounded bg-gray-200 hover:bg-gray-400"
                    :title="`Flag ${service.name}`"
                    :href="
                      `https://twitter.com/share?url=${encodeURIComponent(
                        'https://restimuli.com'
                      )}&text=${encodeURIComponent(
                        `Hi @AdriaanvRossum, there is something wrong with the '${service.name}' listing.\n\n(please replace this line with what is wrong...)\n\n`
                      )}`
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M18.827 7.806c-4.225 0-4.491-6.806-9.666-6.806-1.535 0-2.951.628-4.161 1.482v-2.482h-2v24h2v-10.427c1.064-1.302 2.316-2.021 4.205-2.021 2.219 0 3.592.841 5.368.841 3.127 0 4.938-2.379 6.428-5.083-.832.345-1.547.496-2.174.496zm-4.255 2.588c-1.399 0-2.882-.841-5.368-.841-1.761 0-3.108.508-4.205 1.292v-5.784c.999-.951 2.517-2.061 4.162-2.061 1.621 0 2.444 1.025 3.759 2.836.987 1.359 2.159 2.974 4.022 3.648-.74.633-1.5.91-2.37.91z"
                      />
                    </svg>
                    </a>-->
                    <!-- </div> -->
                    <div
                      class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 items-center"
                    >
                      {{ serviceByCompany.offering_name }}
                      <p class="font-medium text-lg">
                        by
                        <img
                          class="inline rounded-sm mr-1"
                          style="width: 20px; heigth: 20px;"
                          :src="serviceByCompany.favicon_url"
                          v-if="serviceByCompany.favicon_url"
                        /><img
                          class="inline rounded-sm -mr-5 -ml-6 "
                          style="width: 67px;"
                          :src="serviceByCompany.logo_url"
                          v-else-if="!serviceByCompany.favicon_url"
                        />
                        {{ serviceByCompany.company_name }}
                      </p>
                    </div>
                    <p class="text-gray-800 text-base px-6 mb-2 mt-3">
                      <span
                        class="inline-flex rounded-full bg-bluegray-200 px-2 text-xs font-bold little-margin"
                        >{{ serviceByCompany.category }}</span
                      >
                      {{ serviceByCompany.description }}
                    </p>
                    <p
                      class="text-gray-600 text-xs px-6 mb-5"
                      v-if="serviceByCompany.requirement"
                    >
                      <strong>Requirement</strong>
                      {{ serviceByCompany.requirement }}
                    </p>
                    <p
                      :class="
                        `text-${serviceByCompany.driveToPaidColor ||
                          'gray'}-600 text-xs px-6 mb-5`
                      "
                      v-if="serviceByCompany.driveToPaidText"
                    >
                      {{ serviceByCompany.driveToPaidText }}
                    </p>
                  </div>
                </div>
                <div
                  class="flex-none mt-auto bg-white rounded-b rounded-t-none overflow-hidden shadow-lg p-6"
                >
                  <!-- Information on how to apply -->
                  <!-- <p class="text-left text-sm">
                <span v-if="service.how_to_apply_text.endsWith('.')">
                  {{
                  service.how_to_apply_text
                  }}
                </span>
                <span v-else-if="service.how_to_apply_text">{{ service.how_to_apply_text }}.</span>
                <span v-if="service.discount.length > 10">{{ service.discount }}</span>
                </p>-->
                  <!-- Information on location -->
                  <p class="text-gray-800 text-base mb-2 mt-3">
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      >{{ serviceByCompany.supplies_to }}</span
                    >
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      v-if="serviceByCompany.country_of_design"
                      >{{ serviceByCompany.country_of_design }}</span
                    >
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      v-if="serviceByCompany.country_of_manufacture"
                      >{{ serviceByCompany.country_of_manufacture }}</span
                    >
                  </p>

                  <div class="flex items-center justify-start">
                    <!-- This is to change the color and design of the button in case an email and not a url is provided to the how to apply -->
                    <!-- <a
                  :href="
                    service.useEmail
                      ? `mailto:${service.how_to_apply_url_or_email}&subject=Discount%20to%20fight%20COVID-19`
                      : `${service.how_to_apply_url_or_email}?utm_source=restimuli.com`
                  "
                  :class="
                    `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${
                      service.useEmail
                        ? 'text-custom-pink border-2 border-custom-pink py-3'
                        : 'text-white gradient py-4'
                    }`
                  "
                >
                  <svg
                    v-if="service.useEmail"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="#ed6ea0"
                    class="inline mr-2 -ml-2"
                  >
                    <path
                      d="M24 0l-6 22-8.129-7.239 7.802-8.234-10.458 7.227-7.215-1.754 24-12zm-15 16.668v7.332l3.258-4.431-3.258-2.901z"
                    />
                  </svg>-->
                    <!-- <span v-if="service.discount.length > 10">Get this discount</span>
                  <span v-else>Get {{ service.discount }} discount</span>-->
                    <a
                      :class="
                        `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${'text-white gradient py-4'}`
                      "
                    >
                      <span>Know more</span>
                    </a>
                  </div>
                </div>
              </a>

              <!-- this is the flip side of the card -->
              <!-- <a
              class="absolute h-full w-full p-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out opacity-0 fd-sh"
              :href="
                service.how_to_apply_url_or_email.includes('@')
                  ? `${service.url}/?ref=restimuli.com`
                  : service.how_to_apply_url_or_email.includes('?')
                  ? `${service.how_to_apply_url_or_email}&ref=restimuli.com`
                  : `${service.how_to_apply_url_or_email}?ref=restimuli.com`
              "
            >-->
              <a
                class="absolute h-full w-full p-6 flex flex-col flex-shrink transform hover:scale-105 transition duration-150 ease-in-out opacity-0 fd-sh"
                :href="
                  serviceByCompany.how_to_contact_url_or_email.includes('@')
                    ? `${serviceByCompany.how_to_contact_url_or_email}`
                    : serviceByCompany.how_to_contact_url_or_email.includes('?')
                    ? `${serviceByCompany.how_to_apply_url_or_email}`
                    : `${serviceByCompany.how_to_apply_url_or_email}`
                "
              >
                <div
                  class="flex-1 bg-white rounded-t rounded-b-none overflow-hidden shadow"
                >
                  <div
                    class="flex flex-wrap text-left no-underline hover:no-underline"
                  >
                    <div
                      class="w-full font-bold text-xl text-gray-800 px-6 mt-6 mb-2 items-center"
                    >
                      {{ serviceByCompany.offering_name }}
                      <p class="font-medium text-lg">
                        by
                        <img
                          class="inline rounded-sm mr-1"
                          style="width: 20px; heigth: 20px;"
                          :src="serviceByCompany.favicon_url"
                          v-if="serviceByCompany.favicon_url"
                        /><img
                          class="inline rounded-sm -mr-5 -ml-6 "
                          style="width: 67px;"
                          :src="serviceByCompany.logo_url"
                          v-else-if="!serviceByCompany.favicon_url"
                        />
                        {{ serviceByCompany.company_name }}
                      </p>
                    </div>

                    <div
                      class="text-gray-800 text-base px-6 mb-2 mt-3 flex flex-wrap "
                    >
                      <p
                        class="text-xs font-bold mtop-s mright-sm "
                        v-if="serviceByCompany.certification_1"
                      >
                        Certification
                      </p>
                      <p class="text-sm ">
                        {{ serviceByCompany.certification_1 }}
                      </p>
                      <p
                        class="text-sm "
                        v-if="serviceByCompany.certification_2"
                      >
                        , {{ serviceByCompany.certification_2 }}
                      </p>
                      <p
                        class="text-sm "
                        v-if="serviceByCompany.certification_3"
                      >
                        , {{ serviceByCompany.certification_3 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_4"
                      >
                        , {{ serviceByCompany.certification_4 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_5"
                      >
                        , {{ serviceByCompany.certification_5 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_6"
                      >
                        , {{ serviceByCompany.certification_6 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_7"
                      >
                        , {{ serviceByCompany.certification_7 }}
                      </p>
                      <p
                        class="text-sm  "
                        v-if="serviceByCompany.certification_8"
                      >
                        , {{ serviceByCompany.certification_8 }}
                      </p>
                    </div>
                  </div>
                  <p
                    :class="`text-gray-600 text-xs px-6 mb-5 mt-1`"
                    v-if="
                      serviceByCompany.plastic_in_item_or_packaging.includes(
                        'No'
                      )
                    "
                  >
                    {{ serviceByCompany.plastic_in_item_or_packaging }}
                  </p>
                </div>
                <div
                  class="flex-none mt-auto bg-white rounded-b rounded-t-none shadow-lg p-6"
                >
                <!-- Overlay div to grey out the back of the tile -->
                <div
                class="overlay absolute inset-0 bg-gray-300 opacity-70 z-10 m-6"
                v-if="serviceByCompany.driveToPaidFlag"
                ></div>
                <!-- End of Overlay div to grey out the back of the tile --> 
                  <p class="text-gray-800 text-base mb-2 mt-3">
                    <span
                      class="inline-flex rounded-full border border-bluegray-200 bg-white px-2 text-xs font-bold little-margin"
                      >{{ serviceByCompany.type_of_business }}</span
                    >
                  </p>

                  <div class="flex items-center justify-start">
                    <a
                      :href="`${serviceByCompany.how_to_contact_url_or_email}`"
                      :class="
                        `transform hover:scale-105 transition duration-150 ease-in-out mx-auto lg:mx-0 text-sm font-bold rounded-lg mt-4 mb-2 px-8 shadow-lg ${'text-white gradient py-4'}`
                      "
                    >
                      <span>Know more</span>
                    </a>
                  </div>
                </div>
              </a>
            </div>
          </template>
        </div>

        <div v-else-if="loading" class="w-full mt-8">
          <p class="text-center">Loading products...</p>
        </div>
        <div v-else class="w-full mt-8">
          <p class="text-center">Select an option above.</p>
        </div>
      </div>

      
    </section>

    <div class="px-6 sm:hidden mx-auto bg-gray-100 pb-20 pt-10 -mt-1">
      <div
            class="py-4 px-6 shadow border rounded items-center justify-center w-full mt-8 text-center gradient overflow-hidden"
          >
            <p
              class="w-full my-2 text-xl font-bold leading-tight text-gray-800 mb-5"
            >
              Get new company profiles every week!
    </p>
            <form action="https://restimuli.us5.list-manage.com/subscribe/post" method="POST" target="_blank">
                <input type="hidden" name="u" value="f82c7f82dbca46f5f83765b6a">
                <input type="hidden" name="id" value="36cf36b57d">
                <input class="appearance-none bg-white py-2 px-2 focus:outline-none focus:bg-gray-100 focus:border-orange-900 text-sm placeholder-orange-600 newsletter_placeholder border-2 border-white rounded mx-auto flex flex-wrap w-11/12"
            type="email"
            :placeholder="' ' + icon + '   Enter your email...'"
            aria-label="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="">
                 <button class="bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 focus:outline-none" type="submit">
                  Get new profiles
                </button>

                <!-- class="flex-shrink-0 bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 md:mt-0 focus:outline-none" -->

                
             </form> 
          </div>
      </div>

    <!-- Change the colour #f8fafc to match the previous section colour -->
    <svg
      class="wave-top -mt-1"
      viewBox="0 0 1439 147"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g transform="translate(-1.000000, -14.000000)" fill-rule="nonzero">
          <g class="wave" fill="#F4F4F5">
            <path
              d="M1440,84 C1383.555,64.3 1342.555,51.3 1317,45 C1259.5,30.824 1206.707,25.526 1169,22 C1129.711,18.326 1044.426,18.475 980,22 C954.25,23.409 922.25,26.742 884,32 C845.122,37.787 818.455,42.121 804,45 C776.833,50.41 728.136,61.77 713,65 C660.023,76.309 621.544,87.729 584,94 C517.525,105.104 484.525,106.438 429,108 C379.49,106.484 342.823,104.484 319,102 C278.571,97.783 231.737,88.736 205,84 C154.629,75.076 86.296,57.743 0,32 L0,0 L1440,0 L1440,84 Z"
            />
          </g>
          <g transform="translate(1.000000, 15.000000)" fill="#FFFFFF">
            <g
              transform="translate(719.500000, 68.500000) rotate(-180.000000) translate(-719.500000, -68.500000) "
            >
              <path
                d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496"
                opacity="0.100000001"
              />
              <path
                d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z"
                opacity="0.100000001"
              />
              <path
                d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z"
                opacity="0.200000003"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>

    <section class="container mx-auto text-center pt-6">
      <!-- <h1
        class="w-full my-2 text-5xl font-bold leading-tight text-center text-white"
      >
        This list is continuously updated
      </h1>-->
      <!-- <div class="w-full mb-4">
        <div
          class="h-1 mx-auto bg-white w-1/6 opacity-25 my-0 py-0 rounded-t"
        ></div>
      </div>-->

      <h2 class="my-4 mt-8 text-3xl leading-tight ">
        Market your products and company values online
      </h2>

      <p class="mt-12 mb-8">
        <a
          class="mx-auto lg:mx-0 hover:underline bg-white text-gray-800 font-bold rounded-lg py-4 px-8 shadow-lg"
          href="/submit"
          target="_blank"
          >Create a profile</a
        >
      </p>

      <div class="w-full mb-4 mt-20">
        <div
          class="h-1 mx-auto bg-white w-4/6 opacity-25 my-0 py-0 rounded-t"
        ></div>
      </div>


      <form class="w-full max-w-md mx-auto mt-16" action="https://restimuli.us5.list-manage.com/subscribe/post" method="POST" target="_blank">
        <input type="hidden" name="u" value="f82c7f82dbca46f5f83765b6a">
        <input type="hidden" name="id" value="36cf36b57d">
        <div class="flex md:flex-nowrap flex-wrap items-center py-2">          
          <input
            class="appearance-none bg-white w-11/12 lg:w-full lg:mr-3 py-2 px-2 focus:outline-none focus:bg-gray-100 focus:border-orange-900 text-sm placeholder-orange-600 newsletter_placeholder border-2 border-white rounded mx-auto"
            type="email"
            :placeholder="' ' + icon + '   Enter your email...'"
            aria-label="email" autocapitalize="off" autocorrect="off" name="MERGE0" id="MERGE0" size="25" value="">
          <button
            class="flex-shrink-0 bg-custom-pink hover:bg-orange-900 border-custom-pink hover:border-orange-900 text-sm border-2 text-white py-2 px-2 rounded font-medium mx-auto mt-4 md:mt-0 focus:outline-none"
            type="submit"
          >
            Get new profiles
          </button>
        </div>
      </form>

      <div class="text-xs text-orange-300 mt-5">
        <span>
          Join Restimuli's newsletter. By joining, you agree to the
          <a href="/legal" class>Terms of Service</a>
        </span>
      </div>

      <!-- Footer code -->

     <div class="mt-20 text-left">
        <div
          class="max-w-6xl m-auto text-gray-800 flex flex-wrap justify-center"
        >
          <div class="p-5 w-40">
            <div class="text-xs uppercase text-white font-medium">Product</div>
            <a class="my-3 block" href="/submit"
              >Want to see your company profile at Restimuli?<span
                class="text-white text-xs p-1"
              ></span></a
            >
            <!-- <a class="my-3 block" href="/covid"
              >COVID-19 <span class="text-white text-xs p-1">New</span></a
            > -->
          </div>
          <div class="p-5 w-42">
            <div class="text-xs uppercase text-white font-medium">
              Create a profile
            </div>
            <a class="my-3 block" href="/contact"
              >Contact sales <span class="text-white text-xs p-1"></span></a
            >
            <a class="my-3 block" target=”_blank” href="https://publication.restimuli.com/memo/"
              >Suppliers memo  <span class="text-white text-xs p-1">New</span></a
            >
            <!-- <a class="my-3 block" href="/consulting"
              >Book a first 1:1 consultation<span class="text-white text-xs p-1"
                >New</span
              ></a
            > -->
          </div>
          <div class="p-5 w-40">
            <div class="text-xs uppercase text-white font-medium">
              Info
            </div>
            <a class="my-3 block" href="/legal"
              >Privacy & terms <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/contact" target="_blank"
              >Contact us <span class="text-white text-xs p-1"></span
            ></a>
          </div>
          <div class="p-5 w-48 sm:w-40 ">
            <div class="text-xs uppercase text-white font-medium">On us</div>
            <!-- <a class="my-3 block" href="https://twitter.com/restimuli" target="_blank"
              >About us <span class="text-white text-xs p-1"></span>
              </a> -->
            <a class="my-3 block" href="https://publication.restimuli.com/" target="_blank">
              Publication
              <span class="text-white text-xs p-1">New</span>
            </a>  
            <a class="my-3 block" href="/manifesto"
              >Manifesto
            </a>
              <a class="my-3 block" href="/newsletter"
              >Newsletter <span class="text-white text-xs p-1">New</span></a
            >
          </div>
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">Home</div>
            <a class="my-3 block" href="/#"
              >Services <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Products <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >About Us <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Pricing <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Partners <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">User</div>
            <a class="my-3 block" href="/#"
              >Sign in <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >New Account <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Demo <span class="text-white text-xs p-1">New</span></a
            ><a class="my-3 block" href="/#"
              >Career
              <span class="text-white text-xs p-1">We're hiring</span></a
            ><a class="my-3 block" href="/#"
              >Surveys <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Resources
            </div>
            <a class="my-3 block" href="/#"
              >Documentation <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Tutorials <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Support <span class="text-white text-xs p-1">New</span></a
            >
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Product
            </div>
            <a class="my-3 block" href="/#"
              >Our Products <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Great Deals <span class="text-white text-xs p-1">New</span></a
            ><a class="my-3 block" href="/#"
              >Analytics <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Mobile <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Support
            </div>
            <a class="my-3 block" href="/#"
              >Help Center <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Privacy Policy <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >Conditions <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
          <!-- <div class="p-5 w-48">
            <div class="text-xs uppercase text-white font-medium">
              Contact us
            </div>
            <a class="my-3 block" href="/#"
              >XXX XXXX, Floor 4 San Francisco, CA
              <span class="text-white text-xs p-1"></span></a
            ><a class="my-3 block" href="/#"
              >contact@company.com <span class="text-white text-xs p-1"></span
            ></a>
          </div> -->
        </div>
      </div>
      <!-- End of Footer code -->

      <div class="pt-2 text-left">
        <div
          class="flex pb-5 px-3 m-auto pt-5 border-t border-orange-300 text-gray-800 text-sm flex-col md:flex-row max-w-6xl"
        >
          <div class="mt-2">
            © Copyright {{ new Date().getFullYear() }} Restimuli. All Rights
            Reserved.
          </div>
          <div class="md:flex-auto md:flex-row-reverse mt-2 flex-row flex">
            <a href="https://twitter.com/restimuli" target="_blank" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 1000 1000"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Twitter"
                  d="M500 990c270.6 0 490-219.4 490-490S770.6 10 500 10 10 229.4 10 500s219.4 490 490 490zM356 374.5c94.2 47.6 173.8 44.8 173.8 44.8s-30.2-105.2 63.1-151.8c93.3-46.6 157.5 32 157.5 32s16.3-4.5 28.4-8.9c12.1-4.5 29.7-12.4 29.7-12.4l-28.7 51.3 44.3-4.7s-5.5 8-23.2 24.2-25 24.6-25 24.6 6.3 126.6-60.4 224.1-152.9 156-278.1 168.3-206.7-38.4-206.7-38.4 54.7-3.1 89.6-16.5c34.9-13.3 85.1-48.5 85.1-48.5s-71.3-22-97-46.6c-25.6-24.7-32-39.3-32-39.3l70.4-.9s-74.1-39.3-95.1-70.4c-21-31.1-23.8-61.3-23.8-61.3L282 466s-45-61.2-51.4-108.8c-6.4-47.6 8.2-73.2 8.2-73.2s23 42.9 117.2 90.5z"
                />
              </svg>
            </a>
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Facebook"
                  d="M23.998 12c0-6.628-5.372-12-11.999-12C5.372 0 0 5.372 0 12c0 5.988 4.388 10.952 10.124 11.852v-8.384H7.078v-3.469h3.046V9.356c0-3.008 1.792-4.669 4.532-4.669c1.313 0 2.686.234 2.686.234v2.953H15.83c-1.49 0-1.955.925-1.955 1.874V12h3.328l-.532 3.469h-2.796v8.384c5.736-.9 10.124-5.864 10.124-11.853z"
                ></path>
              </svg>
            </a>-->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-gray-500 hover:text-gray-400"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <g id="Layer_1">
                  <circle id="Oval" cx="12" cy="12" r="12"></circle>
                  <path
                    id="Shape"
                    d="M19.05,8.362c0,-0.062 0,-0.125 -0.063,-0.187l0,-0.063c-0.187,-0.562
                     -0.687,-0.937 -1.312,-0.937l0.125,0c0,0 -2.438,-0.375 -5.75,-0.375c-3.25,0
                     -5.75,0.375 -5.75,0.375l0.125,0c-0.625,0 -1.125,0.375
                     -1.313,0.937l0,0.063c0,0.062 0,0.125 -0.062,0.187c-0.063,0.625 -0.25,1.938
                     -0.25,3.438c0,1.5 0.187,2.812 0.25,3.437c0,0.063 0,0.125
                     0.062,0.188l0,0.062c0.188,0.563 0.688,0.938 1.313,0.938l-0.125,0c0,0
                     2.437,0.375 5.75,0.375c3.25,0 5.75,-0.375 5.75,-0.375l-0.125,0c0.625,0
                     1.125,-0.375 1.312,-0.938l0,-0.062c0,-0.063 0,-0.125
                     0.063,-0.188c0.062,-0.625 0.25,-1.937 0.25,-3.437c0,-1.5 -0.125,-2.813
                     -0.25,-3.438Zm-4.634,3.927l-3.201,2.315c-0.068,0.068 -0.137,0.068
                     -0.205,0.068c-0.068,0 -0.136,0 -0.204,-0.068c-0.136,-0.068 -0.204,-0.204
                     -0.204,-0.34l0,-4.631c0,-0.136 0.068,-0.273 0.204,-0.341c0.136,-0.068
                     0.272,-0.068 0.409,0l3.201,2.316c0.068,0.068 0.136,0.204
                     0.136,0.34c0.068,0.136 0,0.273 -0.136,0.341Z"
                    style="fill: rgb(255, 255, 255);"
                  ></path>
                </g>
              </svg>
            </a>-->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Linkedin"
                  d="M7.3,0.9c1.5,-0.6 3.1,-0.9 4.7,-0.9c1.6,0 3.2,0.3 4.7,0.9c1.5,0.6 2.8,1.5
                  3.8,2.6c1,1.1 1.9,2.3 2.6,3.8c0.7,1.5 0.9,3 0.9,4.7c0,1.7 -0.3,3.2
                  -0.9,4.7c-0.6,1.5 -1.5,2.8 -2.6,3.8c-1.1,1 -2.3,1.9 -3.8,2.6c-1.5,0.7
                  -3.1,0.9 -4.7,0.9c-1.6,0 -3.2,-0.3 -4.7,-0.9c-1.5,-0.6 -2.8,-1.5
                  -3.8,-2.6c-1,-1.1 -1.9,-2.3 -2.6,-3.8c-0.7,-1.5 -0.9,-3.1 -0.9,-4.7c0,-1.6
                  0.3,-3.2 0.9,-4.7c0.6,-1.5 1.5,-2.8 2.6,-3.8c1.1,-1 2.3,-1.9
                  3.8,-2.6Zm-0.3,7.1c0.6,0 1.1,-0.2 1.5,-0.5c0.4,-0.3 0.5,-0.8 0.5,-1.3c0,-0.5
                  -0.2,-0.9 -0.6,-1.2c-0.4,-0.3 -0.8,-0.5 -1.4,-0.5c-0.6,0 -1.1,0.2
                  -1.4,0.5c-0.3,0.3 -0.6,0.7 -0.6,1.2c0,0.5 0.2,0.9 0.5,1.3c0.3,0.4 0.9,0.5
                  1.5,0.5Zm1.5,10l0,-8.5l-3,0l0,8.5l3,0Zm11,0l0,-4.5c0,-1.4 -0.3,-2.5
                  -0.9,-3.3c-0.6,-0.8 -1.5,-1.2 -2.6,-1.2c-0.6,0 -1.1,0.2 -1.5,0.5c-0.4,0.3
                  -0.8,0.8 -0.9,1.3l-0.1,-1.3l-3,0l0.1,2l0,6.5l3,0l0,-4.5c0,-0.6 0.1,-1.1
                  0.4,-1.5c0.3,-0.4 0.6,-0.5 1.1,-0.5c0.5,0 0.9,0.2 1.1,0.5c0.2,0.3 0.4,0.8
                  0.4,1.5l0,4.5l2.9,0Z"
                ></path>
              </svg>
            </a>-->
            <!-- <a href="/#" class="w-6 mx-1">
              <svg
                class="fill-current cursor-pointer text-white hover:text-gray-100"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                xml:space="preserve"
                xmlns:serif="http://www.serif.com/"
                style="
                  fill-rule: evenodd;
                  clip-rule: evenodd;
                  stroke-linejoin: round;
                  stroke-miterlimit: 2;
                "
              >
                <path
                  id="Combined-Shape"
                  d="M12,24c6.627,0 12,-5.373 12,-12c0,-6.627 -5.373,-12 -12,-12c-6.627,0
                  -12,5.373 -12,12c0,6.627 5.373,12 12,12Zm6.591,-15.556l-0.722,0c-0.189,0
                  -0.681,0.208 -0.681,0.385l0,6.422c0,0.178 0.492,0.323
                  0.681,0.323l0.722,0l0,1.426l-4.675,0l0,-1.426l0.935,0l0,-6.655l-0.163,0l-2.251,8.081l-1.742,0l-2.222,-8.081l-0.168,0l0,6.655l0.935,0l0,1.426l-3.74,0l0,-1.426l0.519,0c0.203,0
                  0.416,-0.145 0.416,-0.323l0,-6.422c0,-0.177 -0.213,-0.385
                  -0.416,-0.385l-0.519,0l0,-1.426l4.847,0l1.583,5.704l0.042,0l1.598,-5.704l5.021,0l0,1.426Z"
                ></path>
              </svg>
            </a>-->
          </div>
        </div>
      </div>

      
    </section>

    <!-- <div class="absolute right-0">
      <a
        class="flex items-center gradient px-3 py-2 rounded-tl-lg text-white border-t border-l"
        href="https://twitter.com/celue"
      >
        <img class="w-6 rounded-full mr-2" src="/pat.jpg" /> Created by Pat
        Eskinasy
      </a>
    </div> -->

    <div class="flex justify-end">
      <div class="flex items-center gradient px-3 py-2 rounded-tl-lg border-t border-l">
      <span class="text-white font-semibold text-white "> Say hi</span> 
        
      <a class="mx-3 flex flex-row bg-white pr-1 py-0.5 rounded-md text-sm font-semibold" href="https://twitter.com/celue" target="_blank"><img class="w-6 rounded-full mx-1" src="/pat.jpg" />
      <span class="mt-0.5">@celue</span>
      </a>
      
      <a class="mr-2 bg-white px-1 py-1 rounded-md text-sm font-semibold" href="https://twitter.com/restimuli" target="_blank"><span class="align-middle">@restimuli</span></a>
      </div>
    </div>


  </div>
</template>

<script>
import { services } from "@/cache";
import { servicesByCompany } from "@/cache_company_page";
import { format } from "timeago.js";

// console.log({ services });
// console.log({ servicesByCompany });

const BUILD_DATE = process.env.VUE_APP_BUILD_DATE;
const COMMIT_HASH = process.env.VUE_APP_COMMIT_HASH;
//this variable needs to be editted on a company page by company page basis in order to have services only from the company owning this page appearing
const companyNameVar = "Leo Pharma";

export default {
  name: "App",
  data() {
    return {
      json: services,
      jsonByCompany: servicesByCompany,
      error: null,
      services: [],
      servicesByCompany: [],
      loading: true,
      buildDate: BUILD_DATE ? format(BUILD_DATE) : null,
      commitHash: COMMIT_HASH,
      // show: [],
      // show: [
      // "donating",
      //   "",
      //   "medical ppe",
      //   "b2b",
      //   "matches employees donations",
      //   "europe hq"
      // ],
      showDonateSell: [],
      showResource: [],
      category: null,
      icon: "\uf0e0",
      testDonateTile: false,
      linkedinURL: false,
      companyName: false,
      twitterURL: false,
      blogURL: false,
      linkURL: false,
      logoURL: false,
      faviconURL: false,
      companyNameVar: companyNameVar,
    };
  },

  computed: {
    showServicesByCompany() {
      // console.log(this.json);
      // console.log(this.jsonByCompany);
      if (!this.jsonByCompany) return [];

      const cleanByCompany = this.jsonByCompany.map((serviceByCompany) => {
        return Object.keys(serviceByCompany).reduce((c, k) => {
          const key = this.cleanKey(k);
          c[key] = this.cleanValue(key, serviceByCompany[k]);
          return c;
        }, {});
      });

      
      // console.log(this.json);
      // console.log(this.category);
      // console.log(clean);

      const showServicesByCompany = cleanByCompany
        // .filter(
        //   ({ description, name, category }) => description && name && category
        // )
        .filter(({ description, offering_name, category, company_name }) => {
          if (!description || !offering_name || !category || !company_name)
            return false;
          // this is to make sure only the tiles for products belonging to the company owning this page appear
          if (company_name != companyNameVar) return false;
          if (this.category) return category === this.category;

          return true;
        })
        .map((serviceByCompany) => {
          const {
            selling_or_donating: paid,
            favicon,
            linkedin,
            company_name,
            twitter,
            blog,
            url,
            logo_url,
          } = serviceByCompany;

          if (linkedin) {
            this.linkedinURL = serviceByCompany.linkedin;
          // } else {
          //   this.linkedinURL = serviceByCompany.url;
          }

          // console.log(serviceByCompany.linkedin);
          // console.log(this.linkedinURL);

          if (company_name) {
            this.companyName = serviceByCompany.company_name;
          }

          if (twitter) {
            this.twitterURL = serviceByCompany.twitter;
          // } else {
          //   this.twitterURL = serviceByCompany.url;
          }

          if (blog) {
            this.blogURL = serviceByCompany.blog;
          // } else {
          //   this.blogURL = serviceByCompany.url;
          }

          if (url) {
            this.linkURL = serviceByCompany.url;
          }

          if (logo_url) {
            this.logoURL = serviceByCompany.logo_url;
          }

          // console.log(serviceByCompany.category);
          // console.log(serviceByCompany);
          // console.log(serviceByCompany.category);

          if (favicon) {
            const url = !serviceByCompany.url.startsWith("http")
              ? `https://${serviceByCompany.url}`
              : serviceByCompany.url;
            const parts = url.split("/");
            if (parts && parts[2]) {
              const hostname = parts[2];
              const faviconUrl = !favicon.startsWith("http")
                ? `http://${hostname}${
                    favicon.startsWith("/") ? favicon : `/${favicon}`
                  }`
                : favicon;
              // console.log(faviconUrl);
              serviceByCompany.favicon_url = faviconUrl.startsWith("https")
                ? faviconUrl.split("?")[0]
                : null;
            }
            this.faviconURL = serviceByCompany.favicon_url;
          }

          // console.log(favicon);
          // console.log(serviceByCompany.url);

          if (paid) {
            // if (/^maybe/i.test(paid)) {
            //   service.driveToPaid = "maybe";
            //   service.driveToPaidColor = "orange";
            //   service.driveToPaidText =
            //     "Warning: It may drive you into a paid account";
            // }
            if (/^donating/i.test(paid)) {
              serviceByCompany.driveToPaid = "donating";
              serviceByCompany.driveToPaidColor = "green";
              serviceByCompany.driveToPaidText = "Donating";
              serviceByCompany.driveToPaidFlag = true;
              this.testDonateTile = true;
            }
            if (/^selling/i.test(paid)) {
              serviceByCompany.driveToPaid = "selling";
              // serviceByCompany.driveToPaidColor = "red";
              // serviceByCompany.driveToPaidText =
              //   "";
            }
            // serviceByCompany.driveToPaidText += paid.includes(",")
            //   ? ", " + paid.split(",")[1].trim()
            //   : ".";
          }

          // console.log(this.testDonateTile);

          // console.log(service.selectedLocation1);
          // console.log(service.driveToPaid);

          // checking if there is an email in the field
          serviceByCompany.useEmail =
            serviceByCompany.how_to_contact_url_or_email &&
            serviceByCompany.how_to_contact_url_or_email.includes("@");

          // console.log(service.useEmail);

          // console.log(service);
          // console.log(service.url);
          // console.log(service.how_to_apply_url_or_email);

          return serviceByCompany;
        })
        .sort(({ offering_name: left }, { offering_name: right }) => {
          return left.toLowerCase() < right.toLowerCase() ? -1 : 1;
        })
        .sort(({ driveToPaid: left }, { driveToPaid: right }) => {
          if (left === "donating" && ["selling", ""].includes(right)) return -1;
          if (left === "selling" && ["donating", ""].includes(right)) return 1;
          // if (left === "maybe" && ["yes"].includes(right)) return -1;
          // if (left === "maybe" && ["no"].includes(right)) return 1;
          return 0;
        });

      // console.log(showServices);

      // console.log(showServices.length);

      // console.log(this.show);
      // console.log(this.show.length);

      // console.log(this.showDonateSell.length);
      // console.log(this.showDonateSell);

      // console.log(this.showResource.length);
      // console.log(this.showResource);

      // console.log(this.showDonateSell.length + this.showResource.length);

      // let donateSellTest;
      // let resourceTest;

      // this.showDonateSell.length > 0
      //   ? (donateSellTest = true)
      //   : (donateSellTest = false);

      // console.log(this.showDonateSell);

      // console.log(donateSellTest);

      // this.showResource.length > 0
      //   ? (resourceTest = true)
      //   : (resourceTest = false);

      // const filteredCompaniesByDonateSell =
      //   donateSellTest == true
      //     ? showServices.filter(({ driveToPaid }) => {
      //         return this.showDonateSell.includes(driveToPaid);
      //       })
      //     : showServices;

      // const filteredCompaniesByResource =
      //   resourceTest == true
      //     ? filteredCompaniesByDonateSell.filter(({ selectedCategory }) => {
      //         return this.showResource.includes(selectedCategory);
      //       })
      //     : filteredCompaniesByDonateSell;

      // return filteredCompaniesByResource;
      return showServicesByCompany;
    },
  },

  methods: {
    cleanKey(key) {
      return key
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, "_")
        .replace(/(^_|_$)/g, "");
    },
    cleanValue(key, value) {
      if (key === "category" && value.startsWith("Other")) return "Other";
      return value;
    },
  },

  mounted() {
    //Javascript to toggle the hamburguer menu
    document.getElementById("nav-toggle").onclick = function() {
      document.getElementById("nav-content").classList.toggle("hidden");
    };
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
}

#tags-container {
  justify-content: space-between;
}

@media (max-width: 1000px) {
  #tags-container {
    flex-wrap: wrap;
  }
}

#tag-list {
  /* width: 100%; */
  align-items: flex-start;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 25px;
}

@media (max-width: 1000px) {
  #tag-list {
    flex-direction: column;
  }
}

@media (max-width: 600px) {
  #tag-list {
    flex-direction: row;
  }
}

@media (max-width: 1000px) {
  #tag-column {
    flex-direction: column;
    min-width: 49.68%;
  }
}

@media (max-width: 600px) {
  #tag-column {
    display: inline-block;
    min-width: 250px;
    width: auto;
  }
}

#tag-list-header {
  border-bottom: 2px solid #e6e6e6;
  width: fit-content;
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.profile-banner {
  height: 16.5rem;
}

.avatar {
  top: -4.2rem;
}

.content-div:hover .fd-cl {
  opacity: 0.25;
}
.content-div:hover .fd-sh {
  opacity: 1;
}

.little-margin {
  margin-left: 0.07rem;
}
</style>
